<!--
@component Navbar.Group

A component for grouping related items within the navbar. It provides a way to organize and structure navbar content.

@prop label - The accessible label for the group
@prop role - The ARIA role for the group (defaults to "group")
@prop as - The HTML element to render the group as (defaults to "div")
@prop css - Custom CSS styles to be applied to the group

Example:
<Navbar.Group label="User Actions">
  <Button>Sign In</Button>
  <Button>Register</Button>
</Navbar.Group>
-->

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { navbarStyles } from '../navbar.styles';
  import type { NavbarGroupProps } from '../navbar.types';

  /** Props for the Navbar.Group component */
  const { children, css: cssProp, label, role = 'group', as = 'div' }: NavbarGroupProps = $props();

  /** Styles for the navbar group */
  const styles = navbarStyles.raw();
</script>

<svelte:element
  this={as}
  class={css(styles.group, cssProp)}
  {role}
  aria-label={label}
>
  {#if children}
    {@render children()}
  {/if}
</svelte:element>